module.exports = __webpack_public_path__ + "img/9.502e4011.jpg";